// Presentation only: preserve the bot's full identity and instructions when opened.
const EDITORIAL = {
  'book-production-editor': ['Book Editor', 'Polish your manuscript for publication.', 'book', 'blue'],
  'visual-prompt-creative-director': ['Creative Director', 'Give your next idea a clear direction.', 'compass', 'violet'],
  'long-form-narrative-book-architect': ['Book Architect', 'Turn a big idea into a compelling book.', 'book-open', 'amber'],
  'podcast-producer': ['Podcast Producer', 'Shape your next great episode.', 'microphone', 'rose'],
  'slide-deck-designer': ['Slide Designer', 'Make your story presentation-ready.', 'chalkboard', 'blue'],
  'video-producer': ['Video Producer', 'From first concept to a plan for every shot.', 'film', 'violet'],
  'classical-socratic-tutor': ['Socratic Tutor', 'Learn by asking better questions.', 'comments', 'blue'],
  'course-builder': ['Course Builder', 'Build a course that makes learning click.', 'graduation-cap', 'violet'],
  'homeschool-planner': ['Homeschool Planner', 'Bring a little structure to learning at home.', 'house', 'rose'],
  'stem-first-principles-explainer': ['STEM Explainer', 'Make sense of the science behind it.', 'flask', 'amber'],
};

const SPECIALTIES = [
  [/podcast|speech|speaker/, 'microphone', 'rose'],
  [/video|film/, 'film', 'violet'],
  [/slide|presentation/, 'chalkboard', 'blue'],
  [/book|scripture|bible|theolog|sermon/, 'book-open', 'amber'],
  [/security|audit/, 'shield-check', 'blue'],
  [/debug|bug/, 'wrench', 'rose'],
  [/game/, 'gamepad', 'violet'],
  [/code|software|api|python|java|html|css|regex|algorithm|devops|test|release/, 'code', 'blue'],
  [/spreadsheet|table|sql|data/, 'table', 'blue'],
  [/dashboard|financ|pric|valuation|metric/, 'chart-line', 'amber'],
  [/math|proof/, 'calculator', 'blue'],
  [/science|stem|physics|chemistry/, 'flask', 'violet'],
  [/course|study|exam|tutor|learn|flashcard|vocabulary/, 'graduation-cap', 'amber'],
  [/home|family|parent/, 'house', 'rose'],
  [/legal|contract|negotiation/, 'scale-balanced', 'blue'],
  [/research|source|fact|comparison|analy/, 'magnifying-glass', 'blue'],
  [/plan|schedule|calendar|timeline/, 'calendar', 'rose'],
  [/email|newsletter|memo|support/, 'envelope', 'blue'],
  [/brand|visual|creative|design/, 'palette', 'violet'],
  [/market|campaign|sales|launch|growth/, 'bullseye', 'rose'],
  [/writ|edit|content|article|essay|text|story|proposal/, 'pen-nib', 'amber'],
  [/work|project|operation/, 'list-check', 'blue'],
];

const TONES = {
  blue: { light: '#326CA8', dark: '#92BCEB', lightBg: '#EAF1F9', darkBg: '#202D3D' },
  violet: { light: '#795CAE', dark: '#C0A8EB', lightBg: '#F0ECF8', darkBg: '#2E263D' },
  amber: { light: '#986D2D', dark: '#DEBB7E', lightBg: '#F7F0E3', darkBg: '#352E23' },
  rose: { light: '#AA5F68', dark: '#E7A5AF', lightBg: '#FAEDEF', darkBg: '#3A262C' },
};

export function getBotPresentation(agent, dark = false) {
  const editorial = !agent?.isOwner && EDITORIAL[agent?.slug];
  const specialty = SPECIALTIES.find(([pattern]) => pattern.test(String(agent?.name || '').toLowerCase()));
  const tone = TONES[editorial?.[3] || specialty?.[2] || 'blue'];
  const role = agent?.jobRoles?.find(value => typeof value === 'string' && value.trim());
  return {
    name: editorial?.[0] || agent?.name,
    summary: editorial?.[1] || role?.trim() || agent?.description,
    icon: editorial?.[2] || specialty?.[1] || 'sparkles',
    foreground: dark ? tone.dark : tone.light,
    background: dark ? tone.darkBg : tone.lightBg,
    useAvatar: !!agent?.avatarPath,
  };
}
